import { RegExpMatcher, englishDataset, pattern } from 'obscenity';

// Create a matcher with aggressive pattern matching
const matcher = new RegExpMatcher({
    ...englishDataset.build(),
    pattern: pattern.word
});

export const containsProfanity = (text) => {
    if (!text) return false;
    
    try {
        const normalizedText = text
            .toLowerCase()
            // Remove numbers
            .replace(/\d+/g, '')
            // Remove special characters
            .replace(/[^a-z\s]/g, '')
            // Normalize repeated characters (e.g., 'asssss' -> 'ass')
            .replace(/(.)\1+/g, '$1')
            // Remove spaces
            .replace(/\s+/g, '');

        // Check both original and normalized text
        return matcher.hasMatch(text.toLowerCase()) || 
               matcher.hasMatch(normalizedText);
               
    } catch (error) {
        return false;
    }
};
